import { CollapsibleHeader } from '@/shared/components/GridTable/CollapsibleHeader/CollapsibleHeader'
import { GridColumnGroupingModel, GridColumnVisibilityModel } from '@mui/x-data-grid-premium'

export const columnGroupingModel: GridColumnGroupingModel = [
  {
    groupId: 'eta',
    description: 'Estimated Time of Arrival details',
    headerName: 'Stop',
    renderHeaderGroup: (params) => {
      return <CollapsibleHeader
        groupFields={['sequence', 'displayStopType', 'etaTime', 'timeAtStop', 'transitDistance', 'transitTime']}
        numColumnsWhenCollapsed={3}
        {...params}
      />
    },
    children: [
      { field: 'sequence' },
      { field: 'displayStopType' },
      { field: 'etaTime' },
      { field: 'timeAtStop' },
      { field: 'transitDistance' },
      { field: 'transitTime' },
    ],
  },
  {
    groupId: 'orderDetails',
    description: 'Details about the order',
    headerName: 'Order details',
    renderHeaderGroup: (params) => {
      return <CollapsibleHeader
        groupFields={[
          'orderNumber', 'preferredDateOfOperation', 'weight', 'volume', 'orderQuantity', 'timeWindow',
          'serviceTime', 'priority', 'maxOnboardTime', 'portalClientName', 'displayOrderAttributes',
          'tripNumber', 'consignmentNumber', 'description', 'deliveryInstruction', 'comments', 'stopCompartment',
        ]}
        numColumnsWhenCollapsed={1}
        {...params}
      />
    },
    children: [
      { field: 'orderNumber' },
      { field: 'preferredDateOfOperation' },
      { field: 'weight' },
      { field: 'volume' },
      { field: 'orderQuantity' },
      { field: 'timeWindow' },
      { field: 'serviceTime' },
      { field: 'priority' },
      { field: 'maxOnboardTime' },
      { field: 'portalClientName' },
      { field: 'displayOrderAttributes' },
      { field: 'tripNumber' },
      { field: 'consignmentNumber' },
      { field: 'description' },
      { field: 'deliveryInstruction' },
      { field: 'comments' },
      { field: 'stopCompartment' },
    ],
  },
  {
    groupId: 'addressDetails',
    description: 'Address details',
    headerName: 'Address',
    renderHeaderGroup: (params) => {
      return <CollapsibleHeader
        groupFields={['customerAddress', 'customerSuburb', 'customerState', 'customerPostcode', 'customerMapRef', 'customerAdditional']}
        numColumnsWhenCollapsed={1}
        {...params}
      />
    },
    children: [
      { field: 'customerAddress' },
      { field: 'customerSuburb' },
      { field: 'customerState' },
      { field: 'customerPostcode' },
      { field: 'customerMapRef' },
      { field: 'customerAdditional' },
    ],
  },
  {
    groupId: 'customerDetails',
    description: 'Customer details',
    headerName: 'Customer',
    renderHeaderGroup: (params) => {
      return <CollapsibleHeader
        groupFields={['customerNumber', 'customerName']}
        numColumnsWhenCollapsed={1}
        {...params}
      />
    },
    children: [
      { field: 'customerNumber' },
      { field: 'customerName' },
    ],
  },
  {
    groupId: 'depotDetails',
    description: 'Depot details',
    headerName: 'Depot',
    renderHeaderGroup: (params) => {
      return <CollapsibleHeader
        groupFields={['depotCode', 'depotName']}
        numColumnsWhenCollapsed={1}
        {...params}
      />
    },
    children: [
      { field: 'depotCode' },
      { field: 'depotName' },
    ],
  },
  {
    groupId: 'runningTotals',
    description: 'Running totals',
    headerName: 'Running Totals',
    renderHeaderGroup: (params) => {
      return <CollapsibleHeader
        groupFields={['runningWeight', 'runningVolume', 'runningQuantity', 'runningDistance', 'runningWorkingTime']}
        numColumnsWhenCollapsed={2}
        {...params}
      />
    },
    children: [
      { field: 'runningWeight' },
      { field: 'runningVolume' },
      { field: 'runningQuantity' },
      { field: 'runningDistance' },
      { field: 'runningWorkingTime' },
    ],
  },
]

export type ColumnGroupingModelResults = {
  columnGroupingModel: GridColumnGroupingModel
  initialColumnGroupVisibility: GridColumnVisibilityModel
}

// TODO: column grouping models should be dependent on the column definitions retrieved from the server.
export const useColumnGroupingModel = (): ColumnGroupingModelResults => {
  const initialColumnGroupVisibility: GridColumnVisibilityModel = {
    eta: true,
    orderDetails: true,
    addressDetails: true,
    customerDetails: true,
    depotDetails: true,
    runningTotals: true,
  }

  return {
    columnGroupingModel,
    initialColumnGroupVisibility,
  }
}